<template>
  <div
    class="card"
    :class="{
      'card--transparent': transparent,
      'card--success': success,
    }"
  >
    <!-- titre -->
    <div class="card__title">
      <component v-if="icon" :is="icon" class="card__icon" />
      <span v-if="title" v-html="title"></span>

      <!-- buttons -->
      <div v-if="$slots.buttons" class="card__buttons">
        <slot name="buttons" />
      </div>
    </div>

    <!-- infos -->
    <div v-if="$slots.default" class="card__infos">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  icon: {
    type: Object,
    default: () => undefined,
  },
  title: {
    type: String,
    default: () => '',
  },
  transparent: {
    type: Boolean,
    default: () => false,
  },
  success: {
    type: Boolean,
    default: () => false,
  },
})
</script>
